import React from "react";
import Styles from "./CityDescription.module.scss";
import { getFaqListByCity } from "./getFaqList";
import { sanitize } from "isomorphic-dompurify";
import Typography from "@vahak/core-ui/dist/components/Typography";

interface CityDescriptionProps {
    city: string;
}

const CityDescription = ({ city }: CityDescriptionProps) => {
    const { faqList, titleH1Desc, titleH2, titleH2DescList } = getFaqListByCity(city);
    return (
        <div className={Styles.main}>
            <div>
                <h2 className={Styles.desc}>{titleH2}</h2>

                <div className={Styles.descList}>
                    {titleH2DescList?.map((desc, ix) => {
                        return <p key={ix}>{desc.content}</p>;
                    })}
                </div>
            </div>

            <div className={Styles.faq}>
                <h2 className={Styles.faqTitle}>FAQ</h2>

                <ol>
                    {faqList?.map(({ question, answer, descList }: any, ix) => {
                        return (
                            <li key={ix}>
                                <section>
                                    <Typography as="h3">{question}</Typography>
                                    <p>{answer}</p>
                                    {!!descList && (
                                        <ul>
                                            {descList?.map((d: string) => (
                                                <li key={d} dangerouslySetInnerHTML={{ __html: sanitize(d) }} />
                                            ))}
                                        </ul>
                                    )}
                                </section>
                            </li>
                        );
                    })}
                </ol>
            </div>
        </div>
    );
};

export default CityDescription;
